import { elegir } from '../ui/layout-variant.tsx';
import { AjustesMobile } from './Ajustes.mobile.tsx';
import { AjustesDesktop } from './Ajustes.desktop.tsx';

export default elegir<{ onSalir: () => Promise<void> }>(AjustesMobile, AjustesDesktop);
